import "../styles/base.scss";
import "../styles/loader.scss";
import "../styles/landing.scss";
import "../styles/coolLinks.scss";
import "../styles/skills.scss";
import "../styles/projects.scss";
import "../styles/about.scss";
import "../styles/footer.scss";


